module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-06048bb1d81254752f9756b4e5721e3a.png";